import {primaryColor} from "../../constants/constants";

export function DiscunaText() {
    return (
        <span style={{fontWeight: 700, color: "black"}}>discun<span style={{color: primaryColor}}>a</span></span>
    )
}
